import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {getUserData} from '@/auth/utils'

export default function useBannersList(){

    const toast = useToast()

    const refBannerListTable = ref(null)
    const refBannerCategoryListTable = ref(null)

    const tableColumns = [
        {key:'banner_image_path', stickyColumn:true, label:'BANNER'},
        {key:'banner_main_title', label:'MAIN TITLE',  sortable:true},
        {key:'banner_subtitle1', label:'SUBTITLE1',  sortable:true},
        {key:'banner_subtitle2', label:'SUBTITLE2',  sortable:true},
        {key:'actions'}
    ]

    const categoryTableColumns = [
        {key:'label', label:'name'},
        {key:'actions'}
    ]
    const perPage = ref(10)
    const totalBanners = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const categoryOptions = ref([])
    

    const dataMeta = computed(() => {
        const localItemsCount = refBannerListTable.value ? refBannerListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1: 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalBanners.value,
        }
    })

    const showMessage = (title,text,icon, variant) =>{
        toast({
            component: ToastificationContent,
            props: {
              title,
              text,
              icon,
              variant
            },
        })
    }

    const refetchData = () =>{
        refBannerListTable.value.refresh()
    }

    const getBannerImage = (image) =>  process.env.VUE_APP_IMAGE_URL+image

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchBanners = (ctx, callback) => {

        store.dispatch('bar-banner/fetchBanners', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            store_id: getUserData().store_id,
        })
        .then(response => {
            //console.log(response.data)
            const { banners, total} = response.data
            callback(banners)
            totalBanners.value = total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                  title: 'Error fetching banners list',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
            })
        })
    }



    return {
        fetchBanners,
        tableColumns,
        categoryTableColumns,
        perPage,
        currentPage,
        totalBanners,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refetchData,
        refBannerListTable,
        refBannerCategoryListTable,
        getBannerImage,
        categoryOptions,
        showMessage,
        
        
        //Extra Filters
    }

}